import DASHBOARD from './dashboard';
import NHS_PATIENT_DASHBOARD from './nhs_patient_dashboard';
import AD_PATIENT_DASHBOARD from './ad_patient_dashboard';
import NAVIGATION from './navigation';
import NAVIGATION_WEIGHT_UNITS from './navigation_weight_units';
import NAVIGATION_MAIN_NHS from './navigation_main_nhs';
import CHAT from './chat';
import WEIGHTDETAILS from './weight_details';
import FOODDETAILS from './food_details';
import MOODDETAILS from './mood_details';
import EXERCISEDETAILS from './exercise_details';
import DAILYREPORTDETAILS from './daily_report_details';
import SMARTGOALSWEIGHT from './smart_goals_weigh';
import FOODQUESTIONNAIRE from './food_questionnaire';
import COMMUNITY from './community_details';
import ACTIVITY_SUMMARY from './activity_summary';
import NHS_PRACTITIONER_TICKET from './nhs_practitioner_ticket';
import TICKET from './ticket';
import FOODLOGS from './food_logs';
import MOODLOGS from './mood_logs';
import EXERCISELOGS from './exercise_logs';
import FILESTAGS from './file_tags';
import LIBRARYFILES from './library_files';
import MY_FILES_DASHBOARD from './my_files';
import EVENT_CANCEL from './event_cancel';
import ANALYTIC_TICKETS_LOGS from './analytic_tickets_logs';
import ANALYTIC_TICKET_LOGS from './analytic_ticket_logs';
import INVITE from './invite';
import INVITE_SINGLE_FORM from './invite_single_form';
import PRECALL_MEETING from './precall_meeting';
import SURVEY from './survey';
import STATISTIC from './statistic';
import MU_NAVIGATION from './mu_navigation';
import FREETIME_FORM from './freetime_form';
import USER_FORM from './user_form';
import TICKET_REFERRAL from './ticket_referral';
import REFERRAL_EDIT from './referral_edit';
import OPTI_PRACTITIONER_DASHBOARD from './opti_practitioner_dashboard';
import FORM_INVITE from './form_invite';
import ADMIN_CLIENT_MANAGEMENT from './admin_client_management';
import ADMIN_CLIENT_MANAGEMENT_WITH_INVITATIONS from './admin_client_management_with_invitations';
import ADMIN_ORG_MANAGEMENT from './admin_organization_management';
import ADMIN_OWN_ORG from './admin_own_organization';
import SURVEYS from './surveys';
import TICKET_REFERRAL_ANSWER from './ticket_referral_answer';
import SUPPORT from './support';
import REFERRAL_SEARCH_CLIENTS from './referral_search_clients';
import USER_TICKETS from './user_tickets';
import ACTIVITY_PARTICIPANTS_TICKETS_CLOSE from './activity_participants_tickets_close';

// Inside my proptypes.js file
import PropTypes, { oneOfType, arrayOf, shape, number, string } from 'prop-types';

export const widget_structure = {
	content: string.isRequired,
	breakpoints: shape({
		xs: number,
		sm: number,
		md: number,
		xl: number,
	}).isRequired,
	lazy_loading: number /** miliseconds */,
};

export const catalogue_structure = {
	name: string.isRequired /** Options: name of catalogue */,
	sx: oneOfType([arrayOf(oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]) /** MUI sx prop */,
	spacing: number /** Theme spacing options */,
	rowSpacing: number /** Theme rowSpacing options */,
	columnSpacing: number /** Theme columnSpacing options */,
	direction: string /** Options: row, row-reverse, column, column-reverse */,
	justifyContent: string /** Options: flex-start, center, flex-end, space-between, space-around, space-evenly */,
	alignItems: string /** Options: flex-start, center, flex-end, stretch, baseline */,
	widgets: arrayOf(shape(widget_structure)).isRequired,
};

export default {
	DASHBOARD,
	NAVIGATION,
	NAVIGATION_WEIGHT_UNITS,
	NAVIGATION_MAIN_NHS,
	CHAT,
	WEIGHTDETAILS,
	FOODDETAILS,
	MOODDETAILS,
	EXERCISEDETAILS,
	DAILYREPORTDETAILS,
	SMARTGOALSWEIGHT,
	FOODQUESTIONNAIRE,
	NHS_PATIENT_DASHBOARD,
	COMMUNITY,
	ACTIVITY_SUMMARY,
	TICKET,
	NHS_PRACTITIONER_TICKET,
	AD_PATIENT_DASHBOARD,
	FOODLOGS,
	MOODLOGS,
	EXERCISELOGS,
	FILESTAGS,
	LIBRARYFILES,
	MY_FILES_DASHBOARD,
	PRECALL_MEETING,
	INVITE,
	INVITE_SINGLE_FORM,
	ANALYTIC_TICKETS_LOGS,
	ANALYTIC_TICKET_LOGS,
	SURVEY,
	EVENT_CANCEL,
	STATISTIC,
	MU_NAVIGATION,
	FREETIME_FORM,
	USER_FORM,
	TICKET_REFERRAL,
	REFERRAL_EDIT,
	OPTI_PRACTITIONER_DASHBOARD,
	FORM_INVITE,
	ADMIN_CLIENT_MANAGEMENT,
	ADMIN_CLIENT_MANAGEMENT_WITH_INVITATIONS,
	ADMIN_ORG_MANAGEMENT,
	SURVEYS,
	TICKET_REFERRAL_ANSWER,
	ADMIN_OWN_ORG,
	SUPPORT,
  REFERRAL_SEARCH_CLIENTS,
  USER_TICKETS,
  ACTIVITY_PARTICIPANTS_TICKETS_CLOSE
};
